module.exports = __webpack_public_path__ + "static/media/heartipro-charger-2.97b5a43a.png";